(function () {
  angular.module('binky.core.locale', [
    'binky.core.feature',
    'binky.core.lodash',
    'binky.core.src2-migration',
    'pascalprecht.translate',
  ]);
})();
